export default __webpack_public_path__ + "static/media/app-saludsa-link.e43fcbce.svg";